const getBaseUrl = () => {
  const hostname = window.location.hostname;

  // Use environment variable if available (REQUIRED for production)
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  // Localhost - use dev API directly
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return process.env.REACT_APP_DEV_API_URL || 'https://riaqg7zqtj.execute-api.ap-southeast-2.amazonaws.com/dev';
  }

  // Production/Staging - MUST have environment variable set
  if (process.env.REACT_APP_PROD_API_URL) {
    return process.env.REACT_APP_PROD_API_URL;
  }

  // Fallback for development environments
  if (process.env.REACT_APP_DEV_API_URL) {
    return process.env.REACT_APP_DEV_API_URL;
  }

  // If no env variable and not localhost, throw error
  return null;
};

export const API_BASE_URL = getBaseUrl();

export const getFullUrl = (endpoint) => {
  // Check if we're in development mode
  const isDev = process.env.NODE_ENV === 'development';
  
  if (isDev) {
    // For local development, use dev API URL
    return `http://localhost:3001/dev/${endpoint}`;
  } else {
    // For production, use the configured API_BASE_URL
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
    return `${API_BASE_URL}/${cleanEndpoint}`;
  }
};
